<ng-container *ngIf="getUserType() === UserType.seller">
  <ng-container
    *ngIf="
      !!mainService.user.companyStatus &&
      mainService.user.companyStatus !== 'PENDING_VALIDATION' &&
      mainService.user.companyStatus !== 'REJECTED' &&
      mainService.user.companyStatus !== 'PROFILE_CONFIRM' &&
      mainService.user.companyStatus !== 'LEAD' &&
      mainService.user.companyStatus !== 'DANGEROUS'
    ">
    <button mat-icon-button [matMenuTriggerFor]="addMenu">
      <mat-icon style="font-weight: 700">add</mat-icon>
    </button>

    <mat-menu #addMenu="matMenu">
      <button mat-menu-item (click)="newInvoice()">
        <mat-icon>assignment</mat-icon>
        <span>{{ 'SHORTCUT.ADD.NEW_INVOICE' | translate }}</span>
      </button>
      <button mat-menu-item (click)="newClient()">
        <mat-icon>person_add</mat-icon>
        <span>{{ 'SHORTCUT.ADD.NEW_CLIENT' | translate }}</span>
      </button>
    </mat-menu>
  </ng-container>
</ng-container>

<ng-container *ngIf="getUserType() === UserType.buyer">
  <button
    [disabled]="!canDownloadReports"
    mat-icon-button
    [matMenuTriggerFor]="exportMenu">
    <mat-icon style="font-weight: 700">cloud_download</mat-icon>
  </button>
  <mat-menu #exportMenu="matMenu">
    <button mat-menu-item (click)="exportAuctions()">
      <mat-icon>insert_drive_file</mat-icon>
      <span>{{ 'SHORTCUT.EXPORT.AUCTION_AWARDED' | translate }}</span>
    </button>
    <button mat-menu-item (click)="exportAuctionsInProgress()">
      <mat-icon>insert_drive_file</mat-icon>
      <span>{{ 'SHORTCUT.EXPORT.AUCTION_PROGRESS' | translate }}</span>
    </button>
    <button mat-menu-item (click)="exportAuctionsScheduled()">
      <mat-icon>insert_drive_file</mat-icon>
      <span>{{ 'SHORTCUT.EXPORT.AUCTION_FUTURE' | translate }}</span>
    </button>
    <!--    <button mat-menu-item (click)="exportAuctionAdvanced()">-->
    <!--      <mat-icon>insert_drive_file</mat-icon>-->
    <!--      <span>{{'SHORTCUT.EXPORT.AUCTION_AWARDED' | translate}} - ADV</span>-->
    <!--    </button>-->
  </mat-menu>

  <button
    *ngIf="currentFund"
    mat-button
    style="border-radius: 20px"
    [matMenuTriggerFor]="walletMenu"
  >
    {{ currentFund?.name }}
    <mat-icon style="font-weight: 700">arrow_drop_down</mat-icon>
  </button>
  <mat-menu #walletMenu class="full-width">
    <button *ngFor="let fund of buyer?.funds" mat-menu-item (click)="setCurrentFund(fund)">
      <mat-icon *ngIf="currentFund?.id === fund.id">check</mat-icon>
      <mat-icon *ngIf="currentFund?.id !== fund.id"></mat-icon>
      <span>{{ fund.name }}</span>
    </button>
  </mat-menu>

  <button *ngIf="currentFund" mat-button [matMenuTriggerFor]="exportWalletMenu" style="border-radius: 20px">
    <ng-container *ngIf="wallet">
      <mat-icon style="font-weight: 700">account_balance_wallet</mat-icon>
      <span>&nbsp;{{ 'SHORTCUT.WALLET_BALANCE' | translate }}:&nbsp;{{ wallet.balance | currency: 'EUR' }}</span>
    </ng-container>
  </button>
  <mat-menu #exportWalletMenu="matMenu">
    <button mat-menu-item (click)="exportWallet('csv')">{{ 'SHORTCUT.EXPORT_CSV' | translate }}</button>
    <button mat-menu-item (click)="exportWallet('xls')">{{ 'SHORTCUT.EXPORT_XLS' | translate }}</button>
  </mat-menu>
</ng-container>

<ng-container *ngIf="(
                getUserType() === UserType.partner ||
                getUserType() === UserType.partnerBranchMaster ||
                getUserType() === UserType.partnerAgent
              ) &&
              (allowSellerCreate || allowDebtorCreate)">
  <ng-container *ngIf="!!mainService.user.companyStatus && mainService.user.companyStatus === 'ACTIVE'">
    <button mat-icon-button [matMenuTriggerFor]="addMenu">
      <mat-icon style="font-weight: 700">add</mat-icon>
    </button>

    <mat-menu #addMenu="matMenu">
      <ng-container *ngIf="allowSellerCreate || allowDebtorCreate">
        <button mat-menu-item (click)="newCompany()">
          <mat-icon>domain</mat-icon>
          <span>{{ 'SHORTCUT.ADD.NEW_COMPANY' | translate }}</span>
        </button>
      </ng-container>
      <ng-container *ngIf="allowSellerCreate">
        <button mat-menu-item (click)="massiveCompanyImport()">
          <mat-icon>apartment</mat-icon>
          <span>{{ 'SHORTCUT.ADD.MASSIVE_COMPANY_IMPORT' | translate }}</span>
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>
</ng-container>
